import { apiClient } from "../api/apiclient"

export const postcreateTeam = (team, token) =>
    apiClient.post("/create-team", team, {
        headers: { Authorization: `Bearer ${token}` },
    });


export const getAllTeams = (token) =>
    apiClient.get("/teams", {
        headers: { Authorization: `Bearer ${token}` },
    });